import { IRiskAssessmentEditItem, RiskAssessmentEditItem } from "./riskAssessmentEditItem";

export interface IRiskAssessmentEdit {
    canEdit: boolean;
    previousRiskLevel: number;
    previousResidualRiskLevel: number;
    item: IRiskAssessmentEditItem;
}

export class RiskAssessmentEdit implements IRiskAssessmentEdit {
    canEdit: boolean;
    previousRiskLevel: number;
    previousResidualRiskLevel: number;
    item: RiskAssessmentEditItem;

    constructor();
    constructor(obj: IRiskAssessmentEdit);
    constructor(obj?: any) {
        this.canEdit = obj && obj.canEdit || false;
        this.previousRiskLevel = obj && obj.previousRiskLevel || null;
        this.previousResidualRiskLevel = obj && obj.previousResidualRiskLevel || null;
        this.item = new RiskAssessmentEditItem(obj ? obj.item : null);
    }
}